module.exports = {
  title: 'Fancy Bottom Bar with React Native Skia 🎨',
  author: 'Enzo Manuel Mangano',
  date: '2023-02-15',
  slug: 'bottom-bar-skia',
  tags: ['skia', 'react-navigation'],
};
